export default "__VITE_ASSET__BKxyG$Xa__"